export default __webpack_public_path__ + "static/media/tl-bridge.726e5937.png";